import { render, staticRenderFns } from "./my_academic_experience_external_tab.vue?vue&type=template&id=66eb2175"
import script from "./my_academic_experience_external_tab.vue?vue&type=script&lang=js"
export * from "./my_academic_experience_external_tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports